import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useAppDispatch } from "../store";
import { useAuth } from "../contexts/Auth";
import { DrawerContextProvider } from "../contexts/Drawer";
import clienteApi from "../api/cliente.api";
import Header from "./Header";
import Footer from "./Footer";
import Drawer from "./Drawer";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexFlow: "column nowrap",
  justifyContent: "flex-start",
  alignItems: "stretch",
  minHeight: "100vh",
  width: "100vw",
  paddingTop: theme.spacing(8),
}));

const InnerWrapper = styled(Box)({
  display: "flex",
  flexFlow: "row nowrap",
  flexGrow: 1,
  alignItems: "stretch",
  height: "100%",
  width: "100vw",
});

const OutletWrapper = styled(Box)({
  flexGrow: 1,
  display: "flex",
  justifyContent: "start",
  width: "100%",
});

const OutletContainer = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  maxWidth: theme.spacing(150),
  padding: theme.spacing(2),

  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(4, 2),
  },
}));

export default function AuthenticatedLayout() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { cliente, token, logout } = useAuth();

  const load = async (abortController?: AbortController) => {
    try {
      const cliente = await clienteApi.load(undefined, abortController);

      dispatch({ type: "SET_CLIENTE", payload: cliente });
    } catch (error) {
      if (error.status === 401) {
        return logout();
      }

      return Promise.reject();
    }
  };

  useEffect(() => {
    const abortController = new AbortController();

    if (!token) {
      navigate("/login");
    } else if (!cliente) {
      load(abortController);
    }

    return () => {
      abortController.abort();
    };
  }, [location.pathname, token, cliente]);

  return (
    <DrawerContextProvider>
      <Wrapper>
        <Header />
        <InnerWrapper>
          <Drawer />
          <OutletWrapper>
            <OutletContainer>
              <Outlet />
            </OutletContainer>
          </OutletWrapper>
        </InnerWrapper>
        <Footer />
      </Wrapper>
    </DrawerContextProvider>
  );
}
